import React, { useState, useEffect } from "react";
import EventPopup from "../../components/Popup/EventPopup";
import PaginationSection from '../../components/Product/Pagination';
import { EVENT_LIST_URL, EVENT_DETAIL_URL } from "../../utils/urls";
import instance from "../../services/services";
import { useLanguage } from "../../hooks/useLanguage";

function EventList(){
    const { t } = useLanguage();
    const [activeTab, setActiveTab] = useState('Y');
    const [eventPop, setEventPop] = useState(false);
    const [eventList, setEventList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [eventDetail, setEventDetail] = useState(null);
    const itemsPerPage = 4;
    const tabList = [
        {name: t('ongoing_event'), value:'Y' },
        {name: t('ended_event'), value:'N' },
    ];

    useEffect(() => {
        const fetchEventList = async () => {
            try{
                const response = await instance.post(EVENT_LIST_URL, {
                    ing_date_check: activeTab,
                    offset: currentPage,
                    limit: itemsPerPage,
                });
                setTotalCount(response.data.data.cntRow);
                setEventList(response.data.data.data);
            } catch (error) {
                console.error('이벤트 목록 가져오기 실패:', error);
            }
        };
        fetchEventList();
    }, [activeTab, currentPage]);

    const handleTabClick = (value) => {
        setActiveTab(value);
        setCurrentPage(1);
    };

    const handleViewMore = async (eventSeq) => {
        try {
            const response = await instance.post(EVENT_DETAIL_URL, {
                event_seq: eventSeq
            });
            setEventDetail(response.data.data);
            setEventPop(true);
        } catch (error) {
            console.error('이벤트 상세 정보 가져오기 실패:', error);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleArrowClick = (page) => {
        handlePageChange(page);
    };
    return(
        <div className="board_container">
        <h3 className="commu_title noline">{t("event")}</h3>

        <div className="round_tab mb_24">
            <ul className="tab_list">
            {tabList.map((tab, index) => (
                <li
                key={index}
                className={`tab_item ${activeTab === tab.value ? 'active' : ''}`}
                onClick={() => handleTabClick(tab.value)}
                >
                <button className="flex-center-4 flex-justify-center">
                    {tab.name}
                </button>
                </li> 
            ))} 
            </ul>
        </div>

        <div className='event_grid'>
            {eventList.map((event, index) => (
            <div className='event_con' key={index}>
                <figure className='event_poster'>
                    <img src={event?.main_image} alt="event_poster" loading="lazy"/>
                </figure>
                <div className='event_desc_box'>
                    <h3>
                        {event?.event_title}
                    </h3>
                    <div className='event_period'>
                        <p>{t("event_period")}</p>
                        <span>
                            {event?.start_date.split(' ')[0]} ~
                            {event?.end_date ? `${event.end_date.split(' ')[0]}` : ''}
                        </span>
                    </div>
                    <div
                        className="event_desc"
                        dangerouslySetInnerHTML={{
                            __html: (event?.event_summary || '').replace(/\n/g, '<br />'),
                        }}
                    >
                    </div>

                    <button 
                        type='button' 
                        className='event_detail'
                        onClick={() => handleViewMore(event?.event_seq)}
                    >
                        {t("view_details")}
                    </button>
                </div>
            </div>
            ))}
        </div>
        {totalCount > 0 && (
        <div className="pagination_wrap">
            <PaginationSection
                totalCount={totalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onArrow={handleArrowClick}
                />
            </div>
        )}

            <EventPopup
                isPopup={eventPop}
                setIsPopup={setEventPop}
                eventDetail={eventDetail}
            />
        </div>
    )
};

export default EventList;